import LogService from "../CommonSdk/LogService";
import * as ErrorUtils from "../Utils/ErrorUtils";
import * as FetchUtils from "../Utils/FetchUtils";

const LOG_TAG = "GENERIC_FETCH";

export const fetchFile = (url) => {
    return fetch(url)
        .then(response => FetchUtils.parseFetchResponse(response))
        .then(data => {
            if (ErrorUtils.isMainPageIndex(data)) {
                const errorPayload = {
                    errorCode: 404,
                    errorMessage : "page not found. Main page index returned"
                };
                return Promise.reject(errorPayload);
            }
            return Promise.resolve(data);
        })
        .catch(error => {
            const errorPayload = ErrorUtils.parseErrorAndReturnPayload(error);
            const errorMessage = url + " " + errorPayload.errorMessage;
            LogService.error(LOG_TAG, "fetchFile error", errorMessage);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(errorPayload));
        });
}